import React from "react";

type ConsoleMenuBackgroundProps = {};

const ConsoleMenuBackground: React.FC<ConsoleMenuBackgroundProps> = ({}) => {
  // Portaled items must be between the background, and other elements...
  return <div className="console-menu-background" />;
};

export default ConsoleMenuBackground;
